import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function TransitionsModal({
  title,
  desc,
  open,
  setOpen,
  children,
}: {
  title?: string;
  desc?: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children?: React.ReactNode;
}) {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Button
            sx={{ position: "absolute", top: 2, right: 2 }}
            onClick={() => handleClose()}
          >
            X
          </Button>
          {title && (
            <Typography
              sx={{ textAlign: "center", p: 1, pb: 4 }}
              id="transition-modal-title"
              variant="h4"
              component="h2"
            >
              {title}
            </Typography>
          )}
          {desc && (
            <Typography
              sx={{ textAlign: "center", p: 1, mt: 2 }}
              id="transition-modal-description"
            >
              {desc}
            </Typography>
          )}
          {children}
        </Box>
      </Fade>
    </Modal>
  );
}
